import { WidgetData } from './types';

export const temperatureWidgetData: WidgetData = [
  {
    meteoCode: 'TA_PROC=AVE_T=10M_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10,
        timeShift: 0,
        mandatory: false,
      },
    ],
  },
  {
    meteoCode: 'TA_PROC=MAX_T=10M_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10,
        timeShift: 0,
        mandatory: false,
      },
    ],
  },
  {
    meteoCode: 'TA_PROC=MIN_T=10M_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10,
        timeShift: 0,
        mandatory: false,
      },
    ],
  },
];
export const rainWidgetData: WidgetData = [
  {
    meteoCode: 'P_PROC=SUM_T=24H_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 1440, // 1440 мин = 24 часа
        timeShift: 0,
        mandatory: true,
      },
    ],
  },
  {
    meteoCode: 'PD_PROC=AVE_T=24H_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 1440, // 1440 мин = 24 часа
        timeShift: 0,
        mandatory: true,
      },
    ],
  },
];
export const windWidgetData: WidgetData = [
  {
    meteoCode: 'WS_PROC=AVE_T=10M_TYPE=0_Z=10M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10,
        timeShift: 0,
        mandatory: true,
      },
    ],
  },
  {
    meteoCode: 'WD_PROC=AVE_T=10M_TYPE=0_Z=10M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10,
        timeShift: 0,
        mandatory: false,
      }],
  },
  {
    meteoCode: 'WS_PROC=MAX_T=10M_TYPE=0_Z=10M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10, // 1440 мин = 24 часа
        timeShift: 0,
        mandatory: true,
      },
    ],
  },
];
export const levelWaterWidgetData: WidgetData = [
  {
    meteoCode: 'LW_PROC=INS_T=-',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [
      {
        interval: 10,
        timeShift: 0,
        mandatory: false,
      },
    ],
  },
];
